import { selectIsUserAgent } from '../../packages/Filters/shared/selectors';
import { IAppState } from '../common/state';
import { PROFESSIONAL_SEARCH_ENTRY_POINTS } from '../constants/profSearchExperiment';

export const selectIsProfessionalSearchPromoVariant2Visible = (state: IAppState) => {
  const { abUseExperiments } = state;

  const isAgent = selectIsUserAgent(state);

  const experiment = abUseExperiments.find(exp => exp.experimentName === PROFESSIONAL_SEARCH_ENTRY_POINTS);
  const inExperiment = Boolean(experiment && experiment.groupName === 'variant2');

  return isAgent && inExperiment;
};
